import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

/**
 * Identifies this client to our API. The backend uses it to record where a booking was
 * created (web vs mobile — the mobile app sends no header and defaults to mobile there).
 * Only attached to our own API calls; the header name is whitelisted in the API's CORS
 * policy (ClientPlatformHeader in SportBooking.API).
 */
export const CLIENT_PLATFORM_HEADER = 'X-Client-Platform';
export const CLIENT_PLATFORM_WEB = 'web';

export const clientPlatformInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { [CLIENT_PLATFORM_HEADER]: CLIENT_PLATFORM_WEB } }));
};
